<template>
<div id="hotels" :class="{'pa-2 ma-2':$vuetify.breakpoint.smAndUp}">

    <v-container fluid>
        <im-header @add="addHotel()">
            <template v-slot:title>
                <span>{{ $t('hotels.title') }}</span>
            </template>
            <template v-slot:button-name>
                <span v-if="$vuetify.breakpoint.smAndUp">{{ $t('hotels.add_hotel') }}</span>
                 <span v-else>{{ $t('hotels.add_hotel_short') }}</span>
            </template>
        </im-header>

        <!-- SEARCH -->
        <v-row class="im-search pt-3 px-2" no-gutters>
            <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable :placeholder="$t('hotels.search_placeholder')" append-icon="search" hide-details></v-text-field>
        </v-row>
        <!-- ./ SEARCH -->

        <v-container fluid>
            <!--data table-->
            <div class="mx-1">
                <im-table-header class="mt-1" :items="im_header" />
            </div>
            <!--./ data table -->

            <div style="position: relative; height: 3px">
                <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
            </div>
            <template v-if="items.length > 0">
                <!-- DATATABLE ROWS -->
                <v-card tile flat style="background-color: transparent !important;">
                    <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                        <template v-slot:item="props">
                            <im-hotel-item :item="props.item" :hotel_id="hotel.id" :delete_master="master_leo" @click="emitChangeHotel(props.item)" @refresh="getItems()" />
                        </template>
                    </v-data-iterator>
                </v-card>
            </template>
            <div v-else>
                <div class="important pa-2 text-center" v-if="!loading">
                    {{ $t('hotels.table_no_data_message') }}
                </div>
            </div>
        </v-container>

    </v-container>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
import IMTableHeader from '../../components/utils/IMTableHeader.vue';
import IMHotelCard from '../../components/items/Hotel/Card.vue';
import IMHeader from '../../components/utils/IMHeader.vue';

export default {
    name: `hotels`,
    props: ['hotel'],

    components: {
        'im-header': IMHeader,
        'im-table-header': IMTableHeader,
        'im-hotel-item': IMHotelCard,
    },

    data() {
        return {
            master_leo: false,
            status_loading: false,
            // search
            search: null,
            search_timeout: 300,
            // table items
            items: [],

            // table attributes
            loading: false,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 15, 30, 50],

        };
    },

    computed: {
        // imemento table
        im_header() {
            return [
                {
                    text: "Id",
                    width: "8.33%",
                    sortable: false,
                    align: 'center',
                    sort_dir: null,
                },
                {
                    text: this.$t('hotels.table_header.image'),
                    width: "16.64%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('hotels.table_header.name'),
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('hotels.table_header.location'),
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                }, {
                    text: this.$t('hotels.table_header.contact'),
                    width: "25%",
                    sortable: false,
                    sort_dir: null,
                },
            ]
        }
    },

    watch: {
        page: {
            handler() {
                this.getItems();
            }
        },
        size: {
            handler() {
                this.getItems();
            }
        },
        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getItems, 500);
            }
        },
    },

    created() {
        this.getItems();
        this.getUserLeo();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        getItems() {
            // prepare search string
            let search = this.search;
            if(search === "" || search === undefined) {
                search = null;
            }

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/hotels';

            // setup query params
            let params = {
                params: {
                    size: this.size,
                    page: this.page,
                    query: search
                }
            };

            this.$axios.get(endpoint, params)
                .then(response => {
                    this.items = response.data.data;
                    this.total = response.data.pagination.total;
                })
                .catch(error => {
                    this.error('Ooops, something gone wrong');
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },


        getUserLeo() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/users/me';

            this.$axios.get(endpoint)
                .then(response => {
                    this.master_leo = (response.data.email === "stirbu.leonard@mementohub.com");
                })
                .catch(error => {})
                .finally(() => {});
        },

        addHotel() {
            this.$router.push({
                path: '/hotel'
            });
        },

        emitChangeHotel(value) {
            this.$emit('changeHotel', [value.id, true]);
        }
    }
}
</script>
